import { render, staticRenderFns } from "./OrganismQrAccessCreateNew.vue?vue&type=template&id=53d1792c&scoped=true&"
import script from "./OrganismQrAccessCreateNew.vue?vue&type=script&lang=js&"
export * from "./OrganismQrAccessCreateNew.vue?vue&type=script&lang=js&"
import style0 from "./OrganismQrAccessCreateNew.vue?vue&type=style&index=0&id=53d1792c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d1792c",
  null
  
)

export default component.exports